export default __webpack_public_path__ + "static/media/pic4.f8d3e91c.jpg";